export default __webpack_public_path__ + "static/icons-framing-a4aec9c62f9c74226eec51ba9077e498.png";